import React from 'react';
import ContactForm from '../components/ContactForm/ContactForm';

function Contact() {
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      <ContactForm />
    </div>
  );
}

export default Contact;